var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1550px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline ma-0" },
                [
                  _c("v-icon", [_vm._v("close")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        [75, 77].includes(parseInt(_vm.permiso.id_estado))
                          ? "Volver a estado inicial"
                          : "Rechazar papeleta."
                      ) +
                      "\n        "
                  ),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "py-0" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "pa-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "py-0", attrs: { xs12: "" } },
                            [
                              _c("h4", { staticClass: "texto" }, [
                                _c("strong", [_vm._v("Número:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.permiso.numero) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "py-0", attrs: { xs12: "" } },
                            [
                              _c("h4", { staticClass: "texto" }, [
                                _c("strong", [_vm._v("Nombres:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.permiso.nombres) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "py-0", attrs: { xs12: "" } },
                            [
                              _c("h4", { staticClass: "subtitulo-uso" }, [
                                _c("strong", [_vm._v("Detalle de vacación ")])
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "elevation-1 tabla-comprimida-light celda-comprimida",
                                attrs: {
                                  items: _vm.permiso_detalles,
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(props.item.fecha_desde) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(props.item.fecha_hasta) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.hora_desde)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.hora_hasta)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.total_dias)
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "py-0", attrs: { xs12: "" } },
                            [
                              _c("h4", { staticClass: "subtitulo-uso" }, [
                                _c("strong", [
                                  _vm._v("Seguimiento de papeleta")
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "elevation-1 tabla-comprimida-light celda-comprimida",
                                attrs: {
                                  items: _vm.detalle_seguimiento,
                                  headers: _vm.headers_detalle,
                                  "item-key": "id_detalle"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  props.item.fecha_registro
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [_vm._v(_vm._s(props.item.estado))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [_vm._v(_vm._s(props.item.usuario))]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "py-0", attrs: { xs12: "" } },
                            [
                              _c("h4", { staticClass: "subtitulo-uso" }, [
                                _c("strong", [_vm._v("Detalles rechazo")])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-textarea", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  "auto-grow": "",
                                  rows: "2",
                                  label: "Justificación del rechazo",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.justificacion_rechazo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "justificacion_rechazo",
                                      $$v
                                    )
                                  },
                                  expression: "form.justificacion_rechazo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center texto",
                              attrs: { xs12: "" }
                            },
                            [_c("b", [_vm._v("Archivo de respaldo")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              key: _vm.key_actualizacion,
                              staticClass: "text-xs-center",
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  class:
                                    this.file == ""
                                      ? "file-empty"
                                      : "file-upload"
                                },
                                [
                                  _c("v-icon", { attrs: { large: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        this.file == "" ? "file_upload" : "done"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "file",
                                    staticClass: "input-file",
                                    attrs: { type: "file", accept: ".pdf" },
                                    on: {
                                      change: function($event) {
                                        return _vm.handleFileUpload()
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          this.file == ""
                                            ? "Arrastra y suelta cualquier archivo aquí"
                                            : "El archivo se cargo exitosamente!"
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          this.file == ""
                                            ? "o haz click aqui para buscar archivos desde el dispositivo"
                                            : "Arrastra y suelta un archivo o haz click aqui para cambiar de archivo"
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center",
                              attrs: { xs12: "" }
                            },
                            [
                              this.file.size || _vm.adjunto.size_file
                                ? _c(
                                    "div",
                                    { staticClass: "file-block" },
                                    [
                                      _c("v-icon", [_vm._v("description")]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "file-info" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              this.file.name ||
                                                _vm.adjunto.nombre_archivo
                                            ) + " "
                                          )
                                        ]),
                                        _vm._v(
                                          "\n                  |\n                  "
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.size_file_calculate(
                                                  this.file.size
                                                ) ||
                                                  _vm.size_file_calculate(
                                                    _vm.adjunto.size_file
                                                  )
                                              )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.eliminaArchivo()
                                            }
                                          }
                                        },
                                        [_vm._v("delete")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.size
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "red--text body-1 ma-0",
                                      attrs: {
                                        rules: _vm.$validate(["required"])
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                *Archivo demasiado grande(Mayor a 2Mb)\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.denied
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "red--text body-1 ma-0",
                                      attrs: {
                                        rules: _vm.$validate(["required"])
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                *Formato no admitido por el sistema, solo se acepta PDFs\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.file
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "red--text body-1 ma-0",
                                      attrs: {
                                        rules: _vm.$validate(["required"])
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                *No cargo un archivo adjunto\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          [75, 77].includes(parseInt(_vm.permiso.id_estado))
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "justify-center": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "text-xs-center texto",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              "Detalle devolución de saldos -\n                    " +
                                                _vm._s(
                                                  _vm.total_dias_vacaciones
                                                ) +
                                                " día(s)"
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        _vm._l(_vm.l_periodo_saldo, function(
                                          gestion,
                                          index
                                        ) {
                                          return _c(
                                            "v-layout",
                                            {
                                              key: index,
                                              attrs: { row: "", wrap: "" }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { grow: "" } },
                                                [
                                                  _c("v-select", {
                                                    staticClass:
                                                      "text-field-reducido-border",
                                                    attrs: {
                                                      items:
                                                        _vm.l_gestiones_vacaciones,
                                                      "item-value": function(
                                                        val
                                                      ) {
                                                        return parseInt(
                                                          val.periodo
                                                        )
                                                      },
                                                      "item-text": function(
                                                        val
                                                      ) {
                                                        return (
                                                          "Periodo " +
                                                          val.periodo +
                                                          " (" +
                                                          val.gestion_desde +
                                                          "-" +
                                                          val.gestion_hasta +
                                                          ") - Dias saldo: " +
                                                          val.dias_restantes
                                                        )
                                                      },
                                                      label:
                                                        "Periodo a devolver el saldo",
                                                      rules: _vm.$validate([
                                                        "required"
                                                      ]),
                                                      required: "",
                                                      outline: "",
                                                      clearable: ""
                                                    },
                                                    model: {
                                                      value: gestion.periodo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          gestion,
                                                          "periodo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "gestion.periodo"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { grow: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "text-field-reducido-border",
                                                    attrs: {
                                                      label: "Dias",
                                                      type: "number",
                                                      rules: _vm.$validate([
                                                        "required"
                                                      ]),
                                                      required: "",
                                                      outline: "",
                                                      clearable: ""
                                                    },
                                                    model: {
                                                      value: gestion.dias,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          gestion,
                                                          "dias",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression: "gestion.dias"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { shrink: "" } },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    { attrs: { bottom: "" } },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            slot: "activator",
                                                            color: "red",
                                                            icon: "",
                                                            dark: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.eliminarPeriodoSaldo(
                                                                index
                                                              )
                                                            }
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("close")
                                                          ])
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Eliminar")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { shrink: "" } },
                                        [
                                          _c(
                                            "v-tooltip",
                                            { attrs: { bottom: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    slot: "activator",
                                                    color: "primary",
                                                    icon: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.adicionarPeriodoSaldo()
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [_c("v-icon", [_vm._v("add")])],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v("Adicionar periodo")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { loading: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("check")]),
                      _vm._v("\n          Cancelar\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.apruebaRechazaPermiso(_vm.permiso)
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("clear")]),
                      _vm._v("\n          Rechazar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e9a9dde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e9a9dde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/RechazarPermisoRRHH.vue
// module id = null
// module chunks = 